import { createFixture, Fixture, Generator } from 'zod-fixture';

import { getProductFromPricingType } from '../../factories/ProductPricingTypeFactory';
import { DefaultProduct } from '../../stores';
import { DefaultProductConfigDTO } from '../../stores/dtos/product.dtos';
import { getFormConfigTransformer } from '../../stores/transformers/formConfigTransformer';
import { DefaultProductSchema } from '../../types/Schemas.zod';

const AdaptiveUIFormFields = {
  registration_form_details: {
    initial_step_id: 'user_basic_details',
    step_details: [
      {
        step_id: 'user_basic_details',
        step_type: 'DEFAULT',
        next_step_details: {
          step_id: "'success_page'",
          btn_text: 'Poceed ',
          btn_id: 'webinar',
          btn_actions: []
        },
        step_info: {
          title: 'Software Career Employability Test'
        },
        fields_data: [
          {
            type: 'user_name',
            field: 'fullName',
            label: 'Full Name',
            validation_type: 'string',
            validations: [
              {
                type: 'required',
                params: ['*Required']
              }
            ],
            placeholder: 'Enter Your Full Name',
            shouldShowLabel: true,
            tags: ['INTERMEDIATE_PII']
          }
        ]
      },
      {
        step_id: 'success_page',
        step_type: 'CUSTOM_SUCCESS_PAGE',
        fields_data: []
      }
    ]
  },
  form_type: 'MULTI_STEP_PRODUCT_REGISTRATION',
  request_object_extra_fields_data: []
};

const AdaptiveUIMessageConfig = {
  success_payment: {
    title: '<span>Congratulations!</span>',
    description: '<span>See</span>',
    url: 'https://learning.ccbp.in/',
    success_button_text: 'Book Slot',
    submit_button_id: 'webinar'
  },
  failure_payment: {
    title: ' not Successful',
    description: 'Try Again!',
    failure_button_text: 'Retry'
  }
};

const AdaptiveUIFormExtraData = {
  icons: { icon1: 'programs/irc-tech-4.0.svg', alt_text: 'CCBP logo' },
  order: 0,
  product_name: 'CCBP Tech Intensive',
  should_show_refund_policy: false,
  page_description: '',
  payment_error_messages: {},
  should_show_payment_terms_and_conditions: true,
  should_show_coupon_apply_button: true,
  eligible_for_program_change: true,
  payment_details_heading: 'Registration for webinar',
  payment_details_submit_button_text: 'Book Your Free Slot',
  should_show_program_info: true,
  submit_button_id: 'academy-webinar-book-free-webinar'
};

const AdaptiveUIProductInfoConfig = {
  layout: {
    type: 'FORM_SECTION_CENTER'
  },
  branding_section_config: 'success',
  custom_styles: ''
};

const AdaptiveUIProductConfigFixture = {
  extra_data: JSON.stringify(AdaptiveUIFormExtraData),
  user_extra_info_config: JSON.stringify(AdaptiveUIFormFields),
  product_info: JSON.stringify(AdaptiveUIProductInfoConfig),
  product_config: '{}',
  error_messages_config: '{}',
  registration_messages_config: JSON.stringify(AdaptiveUIMessageConfig)
};

export const getDefaultProductConfigZodFixture = () => {
  const baseDetails = createFixture(DefaultProductSchema, { seed: 777 });
  const getProductConfigGeneratorFixture = Generator({
    schema: DefaultProductSchema,
    output: () => ({
      ...baseDetails,
      ...AdaptiveUIProductConfigFixture
    })
  });

  const productConfigZodFixture = new Fixture().extend([
    getProductConfigGeneratorFixture
  ]);

  const productConfigData: DefaultProductConfigDTO = getFormConfigTransformer(
    productConfigZodFixture.fromSchema(DefaultProductSchema)
  );

  const productInfo: DefaultProduct =
    getProductFromPricingType(productConfigData);

  return productInfo;
};
